const DEFAULT_FEATURE_CARDS = [
  { icon: 'LuTrendingUp', title: 'Financial Planning', description: 'Strategic financial roadmaps', order: 0, isActive: true },
  { icon: 'LuFileText', title: 'Financial Reports', description: 'Detailed analysis & insights', order: 1, isActive: true },
  { icon: 'LuUsers', title: 'Expert Consultation', description: 'One-on-one advisory sessions', order: 2, isActive: true },
];

export const getCfoAdvisoryPageMeta = (content) => ({
  pageTitle: content?.pageTitle || 'CFO Advisory',
  pageSubtitle: content?.pageSubtitle || 'Strategic financial guidance for your business',
  pageIcon: content?.pageIcon || 'LuBriefcase',
  cardIcon: content?.cardIcon || 'LuBriefcase',
  cardTitle: content?.cardTitle || 'CFO Advisory Services',
  cardBody: content?.cardBody || 'Get expert financial guidance and strategic advice to help your business grow and succeed.',
  footerNote: content?.footerNote || 'Contact your administrator for more information about CFO Advisory services.',
  featureCards: (content?.featureCards?.length ? content.featureCards : DEFAULT_FEATURE_CARDS)
    .filter((card) => card.isActive !== false)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0)),
});
